<template>
  <div class="satisfaction-level">
      <div class="satisfaction-container">
        <div class="overall-score">
          <div class="score-circle">
            <div class="score-value">{{ overallScore }}</div>
            <div class="score-label">{{ $t('分') }}</div>
          </div>
          <div class="score-description">{{ $t('综合满意度') }}</div>
        </div>
        
        <div class="satisfaction-bars">
          <div class="bar-item" v-for="(item, index) in satisfactionBars" :key="index">
            <div class="bar-label">{{ item.label }}</div>
            <div class="bar-container">
              <div class="bar-fill" :style="{ width: item.percentage + '%', backgroundColor: item.color }">
                <span class="bar-text">{{ item.percentage }}%</span>
              </div>
            </div>
            <div class="bar-count">{{ formatNumber(item.count) }}{{ $t('条') }}</div>
          </div>
        </div>
        
      </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage'

export default {
  name: 'SatisfactionLevel',
  components: {

  },
  data() {
    return {
      overallScore: 4.7,
      satisfactionBars: [
        { label: this.$t('非常满意'), percentage: 65, count: 456, color: '#00E4FF' },
        { label: this.$t('满意'), percentage: 25, count: 175, color: '#00FF88' },
        { label: this.$t('一般'), percentage: 8, count: 56, color: '#FFB800' },
        { label: this.$t('不满意'), percentage: 2, count: 14, color: '#FF4D4F' },
        { label: this.$t('非常不满意'), percentage: 2, count: 14, color: '#E02020' },
      ],
      ratingDistribution: [
        { rating: 5, percentage: 65, count: 456, color: '#00E4FF' },
        { rating: 4, percentage: 25, count: 175, color: '#00FF88' },
        { rating: 3, percentage: 8, count: 56, color: '#FFB800' },
        { rating: 2, percentage: 1.5, count: 10, color: '#FF9F43' },
        { rating: 1, percentage: 0.5, count: 4, color: '#FF4D4F' }
      ],
      url: {
        querySatisfactionTypeInformation: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionTypeInformation",
        querySatisfactionDistributionInformation: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionDistributionInformation",
        querySatisfactionNumByHalf: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionNumByHalf"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      try {
        await this.getData()
        this.animateNumbers()
      } catch (error) {
        console.error('获取满意度数据失败:', error)
        this.loadMockData()
      }
    },
    async getData() {
      try {
        // 获取满意度类型信息
        const typeRes = await postAction(this.url.querySatisfactionTypeInformation, {})
        if (typeRes.success && typeRes.result) {
          const typeData = typeRes.result
          // this.overallScore = typeData.avgSatisfaction || 4.7
          this.overallScore = (typeData.acclaim / (typeData.acclaim+typeData.badReviews) * 100).toFixed(2)

        }

        // 获取满意度分布信息
        const distRes = await postAction(this.url.querySatisfactionDistributionInformation, {})
        if (distRes.success && distRes.result) {
          const distData = distRes.result
          const totalCount = distData.reduce((sum, item) => sum + (item.levelTotal || 0), 0)
          
          this.satisfactionBars = [
            { label: this.$t('非常满意'), percentage: 0, count: 0, color: '#00E4FF' },
            { label: this.$t('满意'), percentage: 0, count: 0, color: '#00FF88' },
            { label: this.$t('一般'), percentage: 0, count: 0, color: '#FFB800' },
            { label: this.$t('不满意'), percentage: 0, count: 0, color: '#FF4D4F' },
            { label: this.$t('非常不满意'), percentage: 0, count: 0, color: '#E02020' },
          ]

          // 映射满意度等级
          distData.forEach(item => {
            const percentage = totalCount > 0 ? ((item.levelTotal / totalCount) * 100).toFixed(1) : 0
            switch(item.level) {
              case 5:
                this.satisfactionBars[0] = { label: this.$t('非常满意'), percentage: Number(percentage), count: item.levelTotal || 0, color: '#00E4FF' }
                break
              case 4:
                this.satisfactionBars[1] = { label: this.$t('满意'), percentage: Number(percentage), count: item.levelTotal || 0, color: '#00FF88' }
                break
              case 3:
                this.satisfactionBars[2] = { label: this.$t('一般'), percentage: Number(percentage), count: item.levelTotal || 0, color: '#FFB800' }
                break
              case 2:
                this.satisfactionBars[3] = { label: this.$t('不满意'), percentage: Number(percentage), count: item.levelTotal || 0, color: '#FF4D4F' }
                break
              case 1:
                this.satisfactionBars[4] = { label: this.$t('非常不满意'), percentage: Number(percentage), count: item.levelTotal || 0, color: '#E02020' }
                break
            }
          })

          // 更新评分分布
          this.ratingDistribution = [
            { rating: 5, percentage: this.satisfactionBars[0].percentage, count: this.satisfactionBars[0].count, color: '#00E4FF' },
            { rating: 4, percentage: this.satisfactionBars[1].percentage, count: this.satisfactionBars[1].count, color: '#00FF88' },
            { rating: 3, percentage: this.satisfactionBars[2].percentage, count: this.satisfactionBars[2].count, color: '#FFB800' },
            { rating: 2, percentage: 0, count: 0, color: '#FF9F43' },
            { rating: 1, percentage: this.satisfactionBars[3].percentage, count: this.satisfactionBars[3].count, color: '#FF4D4F' }
          ]
        }
      } catch (error) {
        console.error('获取满意度数据失败:', error)
        throw error
      }
    },
    loadMockData() {
      this.overallScore = 4.7
      this.satisfactionBars = [
        { label: this.$t('非常满意'), percentage: 65, count: 456, color: '#00E4FF' },
        { label: this.$t('满意'), percentage: 25, count: 175, color: '#00FF88' },
        { label: this.$t('一般'), percentage: 8, count: 56, color: '#FFB800' },
        { label: this.$t('不满意'), percentage: 2, count: 14, color: '#FF4D4F' }
      ]
      this.ratingDistribution = [
        { rating: 5, percentage: 65, count: 456, color: '#00E4FF' },
        { rating: 4, percentage: 25, count: 175, color: '#00FF88' },
        { rating: 3, percentage: 8, count: 56, color: '#FFB800' },
        { rating: 2, percentage: 1.5, count: 10, color: '#FF9F43' },
        { rating: 1, percentage: 0.5, count: 4, color: '#FF4D4F' }
      ]
    },
    animateNumbers() {
      // 数字动画效果
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateBarWidths()
            observer.disconnect()
          }
        })
      })
      
      if (this.$el) {
        observer.observe(this.$el)
      }
    },
    animateBarWidths() {
      // 进度条动画
      const bars = document.querySelectorAll('.bar-fill, .rating-fill')
      bars.forEach((bar, index) => {
        setTimeout(() => {
          bar.style.transition = 'width 1s ease'
        }, index * 100)
      })
    },
    formatNumber(num) {
      return num.toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
.satisfaction-level {
  height: 100%;
  padding: 10px;
}

.satisfaction-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 15px;
}

.overall-score {
  text-align: center;
  margin-bottom: 10px;
}

.score-circle {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: conic-gradient(#00E4FF 0deg, #00FF88 120deg, #FFB800 240deg, #FF4D4F 300deg, #00E4FF 360deg);
  padding: 3px;
  margin-bottom: 8px;
  
  &::before {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: rgba(0, 48, 111, 0.8);
  }
}

.score-value {
  position: relative;
  color: #00E4FF;
  font-size: 24px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
  line-height: 1;
}

.score-label {
  position: relative;
  color: #b6deff;
  font-size: 12px;
  margin-left: 2px;
}

.score-description {
  color: #b6deff;
  font-size: 14px;
  font-weight: 500;
}

.satisfaction-bars {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bar-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bar-label {
  color: #b6deff;
  font-size: 12px;
  width: 60px;
  text-align: right;
  flex-shrink: 0;
}

.bar-container {
  flex: 1;
  height: 12px;
  background: rgba(8, 48, 111, 0.6);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.bar-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.8s ease;
  position: relative;
  
  .bar-text {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 9px;
    font-weight: bold;
  }
}

.bar-count {
  color: #52C4DF;
  font-size: 11px;
  font-weight: bold;
  width: 45px;
  text-align: left;
  flex-shrink: 0;
}

.rating-distribution {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rating-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rating-stars {
  width: 70px;
  flex-shrink: 0;
}

.stars {
  display: flex;
  gap: 1px;
}

.star {
  font-size: 12px;
  
  &.filled {
    color: #00E4FF;
  }
  
  &.empty {
    color: rgba(182, 222, 255, 0.3);
  }
}

.rating-bar {
  flex: 1;
  height: 6px;
  background: rgba(8, 48, 111, 0.6);
  border-radius: 3px;
  overflow: hidden;
}

.rating-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.8s ease;
}

.rating-count {
  color: #52C4DF;
  font-size: 11px;
  font-weight: bold;
  width: 35px;
  text-align: right;
  flex-shrink: 0;
}

@media (max-width: 1600px) {
  .score-circle {
    width: 70px;
    height: 70px;
  }
  
  .score-value {
    font-size: 20px;
  }
  
  .bar-label {
    font-size: 11px;
    width: 55px;
  }
  
  .bar-count {
    font-size: 10px;
    width: 40px;
  }
}

@media (max-width: 1200px) {
  .score-circle {
    width: 60px;
    height: 60px;
  }
  
  .score-value {
    font-size: 18px;
  }
  
  .score-description {
    font-size: 12px;
  }
  
  .bar-label,
  .bar-count,
  .rating-count {
    font-size: 10px;
  }
  
  .star {
    font-size: 10px;
  }
}
</style>